import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
  } from "@material-ui/core";
  import React from "react";
  
  const ViewInvoiceTable = ({ tableItems }) => {
    return (
      <div className="container">
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">ID</TableCell>
                <TableCell align="center">Name</TableCell>
                <TableCell align="center">Description</TableCell>
                <TableCell align="center">Rate</TableCell>
                <TableCell align="center">Quantity</TableCell>
                <TableCell align="center">Tax</TableCell>
                <TableCell align="center">Total</TableCell>
              </TableRow>
            </TableHead>
            {tableItems.length > 0
              ? tableItems.map((item, index) => {
                  return (
                    <TableBody key={index}>
                      <TableRow>
                        <TableCell align="center">{index + 1}</TableCell>
                        <TableCell align="center">{item.name}</TableCell>
                        <TableCell align="center">{item?.description}</TableCell>
                        <TableCell align="center">{item.rate}</TableCell>
                        <TableCell align="center">{item.qty}</TableCell>
                        <TableCell align="center">{item.tax}</TableCell>
                        <TableCell align="center">
                          {item.qty * item.rate}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  );
                })
              : ""}
          </Table>
        </TableContainer>
      </div>
    );
  };
  
  export default ViewInvoiceTable;
  